import React, { useState, useEffect } from "react";
import ObjectForm from "../../Common/ObjectForm";

const PermissionCategoryForm = props => {
  const [formFields, setFormFields] = useState();

  useEffect(() => {
    setFormFields([
      {
        id: "name",
        label: "NAME *",
        type: "text"
      },
    ]);
  }, []);

  return (
    <div>
      {formFields && (
        <ObjectForm
          {...props}
          url={`permission_categories`}
          formName={"Permission Category"}
          formFields={formFields}
        />
      )}
    </div>
  );
};

export default PermissionCategoryForm;
